// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAuth,GoogleAuthProvider} from 'firebase/auth'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBAQfcL6EUrHmrxbWB_3riGc7xcSIi4hJo",
  authDomain: "authentication-91d01.firebaseapp.com",
  projectId: "authentication-91d01",
  storageBucket: "authentication-91d01.appspot.com",
  messagingSenderId: "830214164768",
  appId: "1:830214164768:web:631b5303e532a9cacf4745"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
export {auth,provider};